import {SubScriptWrap, SubScriptTitle, SubScriptDesc, SubScriptContent} from 'src/styles/common/subscript'
import {useLocation} from 'react-router'
import TelChoiceTab from './TelTab'
import InputForm from "src/component/common/CommonForm/InputForm"
import useValid from "src/hooks/useValid"
import Modal from "src/component/common/Modal/Modal";
import useSubscriptQuery from "src/hooks/useSubscriptQuery";
import {CustomBtn} from "src/styles/common/CommonForm/buttonform";
import {COLOR} from "src/service/constant/color";
import useWindowDimensions from "src/hooks/useGetWindowSize";
import DoubleModal from "src/component/common/Modal/DoubleModal";
import {useRecoilValue} from "recoil";
import {CertNumState, DouModalOption} from "src/store/recoil/common";
import JoinTerms from "src/component/Join/JoinTerms";
import useOnInput from "src/hooks/useOnInput";
import Loading from "src/component/common/Loading";
import {useEffect} from "react";

type SubScriptItems = {
    path: string,
    title: string,
    desc: any,
    btnName: string,
    ClickFunc1: () => {},
    ClickFunc2: () => {},
    pc_marginTop: string,
    mo_marginTop: string,
}
const SubScript = () => {
    const valid = useValid()
    const {width} = useWindowDimensions()
    const {join, cancel, login, secureModalCall, securityCheck, JoinIsLoading, CancelIsLoading, loginCertSubmit, douIsOpen, modalSetting, isOpen, douToggle, toggle} = useSubscriptQuery()
    const {pathname} = useLocation()
    const CertNum = useRecoilValue(CertNumState)
    const DouModalSetting = useRecoilValue(DouModalOption)
    const onInput = useOnInput()
    const SubScriptOption: SubScriptItems[] = [
        {
            path: '/join',
            title: '휴대폰가족보호는 가족을 연결하고 보호할 수 있게 돕는 서비스입니다.',
            desc: '휴대폰가족보호는 가족의 실시간 위치와 미사용과 충격감지 기능 등을 통해 위급상황 감지 시 알림을 보내  나와 소중한 우리 가족을 보호할 수 있게 돕는 서비스입니다.',
            btnName: '휴대폰가족보호 유료가입',
            ClickFunc1: secureModalCall,
            ClickFunc2: join,
            pc_marginTop: "56px",
            mo_marginTop: '34px',
        },
        {
            path: '/cancel',
            title: '서비스를 해지하기 전에 아래 내용을 꼭 확인해 주세요.',
            desc: '* 서비스 해지 시 가족의 상황을 확인하고 케어할 수 없습니다. 신중하게 결정해주세요. \n' +
                '* 가입 당일 해지하신 고객님은 요금이 발생하지 않습니다. \n' +
                '* 서비스 이용요금은 매월 사용일 수 만큼 계산되어 청구됩니다.',
            btnName: '서비스해지',
            ClickFunc1: secureModalCall,
            ClickFunc2: cancel,
            pc_marginTop: "14px",
            mo_marginTop: '0px'
        },
        {
            path: '/login',
            title: '회원메뉴에서 내정보보기, 패밀리레터, 오늘의운세를 확인해보세요.',
            desc: '내정보보기에서 가입한 기간, 수신한 패밀리레터와 푸시 등의 수와 연결 중 가족 수를 확인할 수 있습니다. \n' +
                '추가로 건강과 여행에 관련한 유용한 정보인 패밀리레터와 오늘의운세도 확인해보세요.',
            btnName: '로그인하기',
            ClickFunc1: loginCertSubmit,
            ClickFunc2: login,
            pc_marginTop: "14px",
            mo_marginTop: '0px'
        }
    ]
    const Item = SubScriptOption.find((element: any) => (element.path === pathname))

    const setClickFunc = () => {
        switch (true) {
            case modalSetting.option === "인증번호 3회 오류로 만료되었습니다. 다시 진행해 주세요.":
            case modalSetting.option === "유효시간이 초과 되었습니다. 인증번호를 다시 받아 주세요.":
            case modalSetting.setOption === 203:
            case modalSetting.setOption === 216:
            case modalSetting.setOption === 218:
                window.location.reload()
                break;
            default :
                toggle()
                break;
        }
    }

    useEffect(() => {
        if(CancelIsLoading || JoinIsLoading) {
            document.getElementById("common_btn")?.blur()
        }
    }, [CancelIsLoading, JoinIsLoading])
    return (
        <SubScriptWrap>
            {(JoinIsLoading || CancelIsLoading) && <Loading/>}
            <SubScriptTitle>{Item?.title}</SubScriptTitle>
            <SubScriptDesc><p dangerouslySetInnerHTML={{__html: Item?.desc}}/></SubScriptDesc>
            <SubScriptContent>
                <TelChoiceTab/>
                <InputForm
                    title='휴대폰번호'
                    valid={valid.PhoneNumValid}
                    placeholder='‘-’을 제외하고 입력해주세요.'
                    ClickFunc={Item?.ClickFunc1}
                    oninput={onInput.PhoneNum}
                />
                <InputForm
                    title='인증번호'
                    value={CertNum}
                    valid={valid.CertNumValid}
                    oninput={onInput.CertNum}
                    placeholder='인증번호를 입력해주세요.'
                />
            </SubScriptContent>
            {pathname === "/join" && <JoinTerms/>}
            <CustomBtn
                id="common_btn"
                color={COLOR.white}
                bgColor={COLOR.point1}
                borderRadius={"40px"}
                marginTop={width > 1200 ? Item?.pc_marginTop : Item?.mo_marginTop}
                width={width > 1200 ? "356px" : "328px"}
                height={width > 1200 ? "56px" : "44px"}
                fontSize={width > 1200 ? "18px" : "14px"}
                fontFamily={width > 1200 ? "NanumSquareNeoHeavy, sans-serif" : "NotoSansBold, sans-serif"}
                onClick={Item?.ClickFunc2}
                disabled={CancelIsLoading || JoinIsLoading}
            >
                <span>{Item?.btnName}</span>
            </CustomBtn>
            <Modal
                isOpen={isOpen}
                type={modalSetting.type}
                toggle={toggle}
                doubleToggle={douToggle}
                setOption={modalSetting.setOption}
                option={modalSetting.option}
                ClickFunc={setClickFunc}
                ClickFunc2={securityCheck}
            />
            <DoubleModal isOpen={douIsOpen}
                         toggle={toggle}
                         toggle2={douToggle}
                         option={DouModalSetting}
            />
        </SubScriptWrap>
    )
}
export default SubScript
